<section class="page-section">
    <app-shared-task-page *ngIf="taskDetails.uid" [task]="taskDetails"></app-shared-task-page>
</section>
